import Suggestion from './suggestion';

export default Suggestion;
